module.exports = __webpack_public_path__ + "static/img/02042D_1_2_C_20240426_LC.d7250fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02042D_1_2_C_20240426_LC.png
// module id = xUMe
// module chunks = 0